(function (window) {
    "use strict";
    DSV.ui.overlays = {

    //ready to fetch html modal content when service is provided from backend
    loadContent: function(apiUrl){
        if (!apiUrl) {
            return;
        }
        
        fetch(apiUrl)
            .then(response => response.text())
            .then(text => {
                //check for div in returned content, since response sometimes is only comments. No div => no overlay
                text.includes("div") ? this.createOverlay(text) : window.console.log("No content returned from overlay service");
    
            })
            .catch(error => {
                window.console.error(error)
            });
    },

    createOverlay: function(content, button) {
        // init new modal
        let modal = new tingle.modal({
            footer: true,
            stickyFooter: false,
            closeMethods: ['overlay', 'escape'],
            //cssClass: ['custom-class-1', 'custom-class-2'],
            onOpen: function() {
                DSV.ui.focus.trapFocus(modal.modal);
            },
            onClose: function() {
                this.destroy();
                DSV.ui.focus.setExistingFocus();
            },
            beforeClose: function() {
                // here's goes some logic
                // e.g. save content before closing the modal
                return true; // close the modal
                return false; // nothing happens
            }
        });

        // set content
        modal.setContent(content);

        //if modal contains image we need to add an extra function to avoid modal content overflowing after load
        //const modalImage = new Image();
        const modalImageEl = modal.getContent().querySelector('.tingle-modal__image img');
        if (modalImageEl) {
            const modalImage = new Image();
            modalImage.src = modalImageEl.getAttribute('src');
            modalImage.onload = function() {
                modal.checkOverflow(); //https://github.com/robinparisi/tingle/issues/79
            };
        }


        const modalYouTubeEl = modal.getContent().querySelector('iframe[data-consent-src]');

        if (modalYouTubeEl) {
            const videoSrc = modalYouTubeEl.getAttribute('data-consent-src')
            const consentCategory = modalYouTubeEl.getAttribute('data-category-consent')

            if (CookieInformation.getConsentGivenFor(consentCategory)) {
                // here goes the script
                modalYouTubeEl.src = videoSrc;

                //control video size
                DSV.ui.fitvids.init();
            } else {

                window.renewConsent = () => {
                    modal.close();
                    CookieConsent.renew();
                    this.bindOneTimeConsentEvent(button, consentCategory);
                }

                const message = `
                                 <p>${window.CookieInformation.youtubeNotVisibleDescription}</p>
                                 <p></p>
                                 <button class="cta cta--primary" onClick="renewConsent()">Renew Consent</button>`

                // set content
                modal.setContent(message);
            }
        }


        // add a button
        modal.addFooterBtn('Close', 'cta--close', function() {
            // here goes some logic
            modal.close();
        });

        if (document.querySelector('.cta-overlay--close')) {
            document.querySelector('.cta-overlay--close').addEventListener('click', () => {
                modal.close();
            });
        }

        if (document.querySelector('.cta-overlay--changeCountrySite')) {
            document.querySelector('.cta-overlay--changeCountrySite').addEventListener('click', () => {
                DSV.ui.cookies.setCookie('countryCode', DSV.data.iplookup.countryCode, 180);
            });
        }

        this.displayOverlay(modal);
    },

    bindOneTimeConsentEvent: function(trigger, consentCategory) {

        window.addEventListener('CookieInformationConsentGiven', function consentEventHandler(event) {

            if (CookieInformation.getConsentGivenFor(consentCategory)) {
                trigger.click();
            }

            //remove the eventListener after use to avoid multiple instances
            this.removeEventListener("CookieInformationConsentGiven", consentEventHandler);

        }, false);
    },

    displayOverlay: function(modal) {
        // open modal
        modal.open();
    },

    setupOverlayTriggers: function(container) {
        const self = container;
        const overlayContent = self.getAttribute('data-overlay-content');

        self.addEventListener('click', (event) => {
                event.preventDefault();
                this.createOverlay(overlayContent, self);
            });
        }
    };
})(window);